import { render, staticRenderFns } from "./AlterarSenhaToken.vue?vue&type=template&id=0a2018cb&scoped=true&"
import script from "./AlterarSenhaToken.vue?vue&type=script&lang=js&"
export * from "./AlterarSenhaToken.vue?vue&type=script&lang=js&"
import style0 from "./AlterarSenhaToken.vue?vue&type=style&index=0&id=0a2018cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2018cb",
  null
  
)

export default component.exports